import {futureDateValidator} from '@/common/validator/futureDateValidator';
import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    Validators
} from '@angular/forms';
import {Router} from '@angular/router';
import {FarmService} from '@services/farm.service';
import {LoaderService} from '@services/loader.service';
import {MedicationService} from '@services/medication.service';
import {VaccineService} from '@services/vaccine.service';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';
import {splitByUpperCase} from '@/utils/helpers';

@Component({
    selector: 'app-add-vaccine',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: './add-vaccine.component.html',
    styleUrl: './add-vaccine.component.scss'
})
export class AddVaccineComponent implements OnInit {
    public vaccineForm: FormGroup;
    public currentDate: string;
    public isAuthLoading = false;
    public isLoading$: Observable<boolean>;
    public splitByUpperCase = splitByUpperCase;

    public hatcheryVaccination: any = [];
    public suppliers: any[] = [];
    public applications: any[] = [];
    public classifications: any[] = [];
    public farmlist: any[] = [];
    public UserDetail: any;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private toastr: ToastrService,
        private loaderService: LoaderService,
        private vaccineService: VaccineService,
        private medicationService: MedicationService,
        private farmService: FarmService
    ) {}

    ngOnInit(): void {
        this.UserDetail = JSON.parse(localStorage.getItem('UserDetail'));
        const today = new Date();
        this.currentDate = today.toISOString().split('T')[0];
        this.vaccineForm = this.fb.group({
            brand: ['', Validators.required],
            arabicBrandName: ['', Validators.pattern(/^[\u0600-\u06FF0-9-\s]+$/)],
            supplierTypeId: ['', Validators.required],
            expireDate: ['', [Validators.required, futureDateValidator()]],
            batchNumber: ['', Validators.required],
            vaccineTypeId: ['', Validators.required],
            sku: [''],
            qty: ['', [Validators.required, Validators.min(0)]],
            applicationId: ['', Validators.required],
            hatcheryTypeId: ['', Validators.required],
            farmId: ['', Validators.required],
            chickAgeFrom: ['', [Validators.required, Validators.min(0)]],
            chickAgeto: ['', [Validators.required, Validators.min(0)]],
            lowStockLevel: ['', Validators.required]
        });

        this.getSupplierTypeList();
        this.getApplicationTypeList();
        this.getClassificationTypeList();
        this.getHatcheryVaccinationList();
        this.getFarmList(this.UserDetail.id);
    }

    getSupplierTypeList() {
        this.medicationService.getSuppierList().subscribe((result) => {
            this.suppliers = result;
        });
    }

    getApplicationTypeList() {
        this.medicationService.getApplicationTypeList().subscribe((result) => {
            this.applications = result;
        });
    }

    getClassificationTypeList() {
        this.medicationService.getClassificationList().subscribe((result) => {
            this.classifications = result;
        });
    }

    getHatcheryVaccinationList() {
        this.vaccineService.getVaccinationList().subscribe((result: any) => {
            this.hatcheryVaccination = result;
        });
    }

    getFarmList(userId: number) {
        this.farmService.getFarmList(userId).subscribe((result) => {
            this.farmlist = result;
        });
    }

    triggerDatePicker(event: any): void {
        const dateInput = event.target;
        dateInput.focus();
        dateInput.click();
    }

    onSubmit() {
        this.loaderService.showLoader();
        this.isAuthLoading = true;

        if (!this.vaccineForm.valid) {
            this.loaderService.hideLoader();
            this.vaccineForm.markAllAsTouched();
            this.isAuthLoading = false;
            this.toastr.error('Please fill the required fields');
            return;
        }
        const vaccineData = {
            ...this.vaccineForm.value
        };

        this.vaccineService.addVaccineDetail(vaccineData).subscribe({
            next: (response) => {
                setTimeout(() => {
                    this.isAuthLoading = false;
                    this.loaderService.hideLoader();
                    this.toastr.success('Vaccine detail Added Successfully');
                }, 2000);
                this.router.navigate(['/vaccine-list']);
            },
            error: (error) => {
                setTimeout(() => {
                    this.isAuthLoading = false;
                    this.loaderService.hideLoader();
                    this.toastr.error(error.error);
                }, 2000);
            }
        });
    }
    onClose(): void {
        this.router.navigate(['/vaccine-list']);
    }
}
